import { useDispatch } from "react-redux";
import TableAccordion from "../../../../Components/TableAccordion";
import { TextEditor } from "../../../../Components/TextEditor";
import { showModal } from "../../../../../../../redux/actions/modal";

import styles from "./businessinfo.module.scss";

interface IBusinessInfo {
  data: any;
  setBusinessComments: React.Dispatch<
    React.SetStateAction<{
      business_comment: string;
      industry_comment: string;
      ownership_comment: string;
      governance_and_management_comment: string;
      borrower_info: string;
    }>
  >;
  defaultValue: string;
  readOnly: boolean;
}

const BusinessInfo = ({
  data,
  setBusinessComments,
  defaultValue,
  readOnly,
}: IBusinessInfo) => {
  const dispatch = useDispatch();

  const handleChange = (data: string) => {
    setBusinessComments((prev) => {
      return {
        ...prev,
        business_comment: data,
      };
    });
  };

  const handleClick = () => {
    dispatch(
      showModal({
        modalIdentifier: "creditanalysisbusinessinforeview",
        dataRecord: {
          data: data,
        },
      })
    );
  };

  return (
    <div className={styles.BusinessInfo}>
      <TableAccordion
        title={<span className={styles.Title}>BUSINESS INFORMATION</span>}
        isDefaultOpen
      >
        <TextEditor
          onChange={handleChange}
          defaultValue={defaultValue}
          readOnly={readOnly}
        />
        <div className={styles.ActionBar}>
          <span onClick={handleClick}>View Details</span>
        </div>
      </TableAccordion>
    </div>
  );
};

export default BusinessInfo;
